import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";

import { getRole } from "../../http/fundLync/role.helper";

// Column
import { decryptedValue, isPermission } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";
import { useToast } from "ToastStore";
import ToastDialog from "components/Common/ToastDialog";

const TableActionsComponent = (rowData) => {
  const navigate = useNavigate();

  const navigateToEditRoles = (id) => {
    const encryptedId = btoa(id.toString());
    const user = decryptedValue(localStorage.getItem("user"));
    navigate(`/${user.roleName}/edit-roles?id=${encodeURIComponent(encryptedId)}`);
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => { navigateToEditRoles(rowData.id) }
          }
        >
          <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
          Edit
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}



const Roles = props => {

  //meta title
  document.title = "Roles | FundLync";

  const navigate = useNavigate();

  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("asc");
  const [isNewRolePermission, setIsNewRolePermission] = useState(false)
  const [sortingOptions, setSortingOptions] = useState({ column: 'id', isAsc: false, optionalColumn: ['Action', 'address'] })
  const [roleList, setRoleList] = useState([]);
  const user = decryptedValue(localStorage.getItem("user"));

  const { message, showToast, role, handleHideToast } = useToast()
  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
        }
      },
      {
        Header: 'Display Name',
        accessor: 'displayName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
          ;
        }
      },
      {
        Header: 'Description',
        accessor: 'roleDescription',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
        }
      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData)
        }
      },
    ],
    []
  );

  const handlePageChange = (page, pageSize, searchKey, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    getRole({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setRoleList(responseFromAPI.data.data);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setRoleList([])
        }
      }).catch(error => { })

  }

  const handleSortColumn = (option) => {
    setSortingOptions(option)
    const columnName = option.column;
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
  }

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value)
    handlePageChange(1, pageSize, value);
  }
  const handleClearSearch = () => {
    setSearchValue("")
    handlePageChange(1, pageSize, "")
  }

  useEffect(() => {
    getRole()
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setRoleList(responseFromAPI.data.data);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
        }
      }).catch(error => { })

    checkPermissions()
  }, []);

  const checkPermissions = async () => {

    const isNewRole = await isPermission("roles", "create_permission")
    setIsNewRolePermission(isNewRole)
  }

  const handleCustomerClicks = () => {
    const user = decryptedValue(localStorage.getItem("user"));
    navigate(`/${user.roleName}/add-roles`)
  };
  const buttonSection = (
    <div className="text-sm-end">
      {isNewRolePermission &&
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-2"
          onClick={handleCustomerClicks}
        >
          <i className="mdi mdi-plus me-1" />
          {'New Role'}
        </Button>
      }
    </div>);

  const handleNavigatePermission = () => {
    navigate(`/${user.roleName}/permission`);
  };

  const handleNavigateRolePermission = () => {
    navigate(`/${user.roleName}/custom-roles-permission`);
  };
  return (
    <div className="page-content">
      <Container fluid>
        <Col style={{
          width: '100%'
        }}
          className="d-flex justify-content-between align-items-center mb-3">
          <Breadcrumbs title="ROLE LIST" />
          <div>
            <button
              onClick={handleNavigateRolePermission}
              className="btn btn-outline-success ms-4"
              type="button"
            >
              Show Role Permissions
            </button>

            <button
              onClick={handleNavigatePermission}
              className="btn btn-outline-success ms-4"
              type="button"
            >
              Show Permissions
            </button>
          </div>
        </Col>
        <Row className="vertical-scroll">
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={roleList}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastDialog
        message={message}
        showToast={showToast}
        role={role}
        onCloseFn={handleHideToast}
      />
    </div>
  );
};



export default Roles;
